import React from "react";
import { FaAirbnb, FaWhatsapp, FaInstagram } from "react-icons/fa";

const Footer = () => {
  return (
    <div className="bg-[#E8E4DE] text-[#948A78] text-sm py-10 px-5 lg:px-[10%] 2xl:px-[15%]">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-16">
        <div className="grid grid-cols-[100px_auto] md:grid-cols-[200px_auto] w-full justify-center md:justify-start order-2 md:order-2">
          <div>
            <p className="text-right text-base">
              Slow down <br /> with Us
            </p>

            <p className="hidden md:block text-right text-base mt-5">
              Scan to check availibility <br />
              or speak with us
            </p>
          </div>

          <div className="flex flex-col gap-5 -ml-5 sm:ml-0 mt-20 md:mt-36 uppercase text-xs">
            <a href="/" style={{ letterSpacing: "2px", wordSpacing: "2px" }}>
              houseoftao.goa@gmail.com
            </a>

            <a href="/" style={{ letterSpacing: "2px", wordSpacing: "2px" }}>
              +91 8866262368
            </a>

            <a href="/" style={{ letterSpacing: "2px", wordSpacing: "2px" }}>
              @houseoftao
            </a>

            <br />

            <a href="/" style={{ letterSpacing: "2px", wordSpacing: "2px" }}>
              sohamvillas@gmail.com
            </a>

            <a href="/" style={{ letterSpacing: "2px", wordSpacing: "2px" }}>
              +91 7767047535
            </a>

            <a href="/" style={{ letterSpacing: "2px", wordSpacing: "2px" }}>
              @sohamvillas
            </a>
          </div>

          <div className="col-span-2 md:hidden mt-10">
            <div className="flex gap-2 items-center justify-center">
              <a
                href="https://airbnb.co.in/h/houseoftao"
                target="_blank"
                rel="noopener noreferrer"
                className="group scale-90 w-11 hover:w-32 h-10 hover:bg-transparent relative bg-transparent rounded text-neutral-50 duration-700 before:duration-700 before:hover:500 font-bold flex justify-start gap-2 items-center p-2 pr-6 before:absolute before:-z-10 before:right-7 before:hover:right-32 before:w-6 before:h-5 before:bg-transparent before:hover:bg-transparent before:rotate-45"
              >
                <FaAirbnb className="w-7 h-7 shrink-0 group-hover:fill-pink-600 fill-[#97928c]" />
                <span className="origin-left text-pink-600 inline-flex duration-100 group-hover:duration-300 group-hover:delay-500 opacity-0 group-hover:opacity-100 border-pink-600 border-l-2 px-1 transform scale-x-0 group-hover:scale-x-100 transition-all">
                  Airbnb
                </span>
              </a>

              <a
                href="https://wa.me/918490984907"
                target="_blank"
                rel="noopener noreferrer"
                className="group scale-90 w-11 hover:w-32 h-10 hover:bg-transparent relative bg-transparent rounded text-neutral-50 duration-700 before:duration-700 before:hover:500 font-bold flex justify-start gap-2 items-center p-2 pr-6 before:absolute before:-z-10 before:right-7 before:hover:right-32 before:w-6 before:h-5 before:bg-transparent before:hover:bg-transparent before:rotate-45"
              >
                <FaWhatsapp className="w-7 h-7 shrink-0 group-hover:fill-green-600 fill-[#948A78]" />
                <span className="origin-left text-green-600 inline-flex duration-100 group-hover:duration-300 group-hover:delay-500 opacity-0 group-hover:opacity-100 border-green-600 border-l-2 px-1 transform scale-x-0 group-hover:scale-x-100 transition-all">
                  WhatsApp
                </span>
              </a>

              <a
                href="https://www.instagram.com/houseoftao.goa"
                target="_blank"
                rel="noopener noreferrer"
                className="group scale-90 w-11 hover:w-32 h-10 relative bg-transparent rounded text-neutral-50 duration-700 before:duration-700 font-bold flex justify-start gap-2 items-center p-2 pr-6 before:absolute before:-z-10 before:right-7 before:hover:right-32 before:w-6 before:h-5 before:bg-transparent before:hover:bg-transparent before:rotate-45"
              >
                <FaInstagram className="w-7 h-7 shrink-0 group-hover:text-pink-600 bg-gradient-to-r from-yellow-400 via-pink-500 to-purple-600 bg-clip-text text-[#948A78]" />
                <span className="origin-left text-pink-600 inline-flex duration-100 group-hover:duration-300 group-hover:delay-500 opacity-0 group-hover:opacity-100 border-pink-600 border-l-2 px-1 transform scale-x-0 group-hover:scale-x-100 transition-all">
                  Instagram
                </span>
              </a>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-[100px_auto] w-full md:mt-10 order-1 md:order-2">
          <p className="text-right text-base">
            Be the First <br /> to Know
          </p>

          <div>
            <p className="mt-16 max-w-[300px]">
              Join the House of Tāo circle and receive early updates on
              bookings, curated experiences, and future retreats.
            </p>

            <div className="flex justify-between gap-1 mt-5">
              <input
                type="text"
                name="email"
                placeholder="example@gmail.com"
                className="w-full bg-transparent focus:ring-0 focus:outline-none placeholder:text-[#948A78] text-[#2a2524] border border-b-[#4F423B]"
              />

              <button
                type="submit"
                className="text-[#4F423B] border border-b-[#4F423B]"
              >
                Connect
              </button>
            </div>
          </div>
        </div>

        <div className="col-span-2 hidden md:block order-3">
          <div className="flex gap-2 items-center justify-center">
            <a
              href="https://airbnb.co.in/h/houseoftao"
              target="_blank"
              rel="noopener noreferrer"
              className="group scale-90 w-11 hover:w-32 h-10 hover:bg-transparent relative bg-transparent rounded text-neutral-50 duration-700 before:duration-700 before:hover:500 font-bold flex justify-start gap-2 items-center p-2 pr-6 before:absolute before:-z-10 before:right-7 before:hover:right-32 before:w-6 before:h-5 before:bg-transparent before:hover:bg-transparent before:rotate-45"
            >
              <FaAirbnb className="w-7 h-7 shrink-0 group-hover:fill-pink-600 fill-[#97928c]" />
              <span className="origin-left text-pink-600 inline-flex duration-100 group-hover:duration-300 group-hover:delay-500 opacity-0 group-hover:opacity-100 border-pink-600 border-l-2 px-1 transform scale-x-0 group-hover:scale-x-100 transition-all">
                Airbnb
              </span>
            </a>

            <a
              href="https://wa.me/918490984907"
              target="_blank"
              rel="noopener noreferrer"
              className="group scale-90 w-11 hover:w-32 h-10 hover:bg-transparent relative bg-transparent rounded text-neutral-50 duration-700 before:duration-700 before:hover:500 font-bold flex justify-start gap-2 items-center p-2 pr-6 before:absolute before:-z-10 before:right-7 before:hover:right-32 before:w-6 before:h-5 before:bg-transparent before:hover:bg-transparent before:rotate-45"
            >
              <FaWhatsapp className="w-7 h-7 shrink-0 group-hover:fill-green-600 fill-[#948A78]" />
              <span className="origin-left text-green-600 inline-flex duration-100 group-hover:duration-300 group-hover:delay-500 opacity-0 group-hover:opacity-100 border-green-600 border-l-2 px-1 transform scale-x-0 group-hover:scale-x-100 transition-all">
                WhatsApp
              </span>
            </a>

            <a
              href="https://www.instagram.com/houseoftao.goa"
              target="_blank"
              rel="noopener noreferrer"
              className="group scale-90 w-11 hover:w-32 h-10 relative bg-transparent rounded text-neutral-50 duration-700 before:duration-700 font-bold flex justify-start gap-2 items-center p-2 pr-6 before:absolute before:-z-10 before:right-7 before:hover:right-32 before:w-6 before:h-5 before:bg-transparent before:hover:bg-transparent before:rotate-45"
            >
              <FaInstagram className="w-7 h-7 shrink-0 group-hover:text-pink-600 bg-gradient-to-r from-yellow-400 via-pink-500 to-purple-600 bg-clip-text text-[#948A78]" />
              <span className="origin-left text-pink-600 inline-flex duration-100 group-hover:duration-300 group-hover:delay-500 opacity-0 group-hover:opacity-100 border-pink-600 border-l-2 px-1 transform scale-x-0 group-hover:scale-x-100 transition-all">
                Instagram
              </span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
